import React from 'react';
import { motion } from 'framer-motion';

const LoadingIndicator = () => (
  <motion.div
    className="fixed inset-0 bg-indigo-900/40 backdrop-blur-sm flex items-center justify-center z-50"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
  >
    <motion.div
      className="bg-white p-6 rounded-xl shadow-xl flex flex-col items-center"
      initial={{ scale: 0.9, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ type: "spring", damping: 20 }}
    >
      <motion.div
        className="w-12 h-12 border-4 border-indigo-200 border-t-indigo-600 rounded-full mb-4"
        animate={{ rotate: 360 }}
        transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
      />
      <p className="text-indigo-700 font-medium">Cargando...</p>
    </motion.div>
  </motion.div>
);

export default LoadingIndicator;